import { defaultPropertiesData as triggerDefaultData } from '@/pages/workflows/builder-data/nodes/trigger/default-properties-data';
import { defaultPropertiesData as actionDefaultData } from '@/pages/workflows/builder-data/nodes/action/default-properties-data';

export function generateBidApprovalNotification(recordId: string) {
  const triggerNode = {
    id: "trigger-1",
    type: "trigger",
    position: { x: 100, y: 100 },
    data: {
      properties: {
        ...triggerDefaultData,
        type: "eventBasedTrigger",
        eventType: "on_bid_approved",
      }
    }
  };

  const actionNode = {
    id: "action-1",
    type: "action",
    position: { x: 500, y: 100 },
    data: {
      properties: {
        ...actionDefaultData,
        type: "sendEmail",
        sendEmail: {
          ...actionDefaultData.sendEmail,
          subject: "Bid Approved!",
          body: `The bid with ID ${recordId} has been approved.`,
          priority: "high",
        }
      }
    }
  };

  const edges = [
    {
      id: "edge-1",
      source: "trigger-1",
      target: "action-1",
      type: "smoothstep"
    }
  ];

  return { nodes: [triggerNode, actionNode], edges };
}

export function generateFollowUpReminder(recordId: string) {
  const triggerNode = {
    id: "trigger-1",
    type: "trigger",
    position: { x: 100, y: 100 },
    data: {
      properties: {
        ...triggerDefaultData,
        type: "eventBasedTrigger",
        eventType: "on_bid_submitted",
      }
    }
  };

  const delayNode = {
    id: "delay-1",
    type: "delay",
    position: { x: 500, y: 100 },
    data: {
      properties: {
        duration: "3",
        unit: "days",
      }
    }
  };

  const actionNode = {
    id: "action-1",
    type: "action",
    position: { x: 900, y: 100 },
    data: {
      properties: {
        ...actionDefaultData,
        type: "createRecord",
        createRecord: {
          ...actionDefaultData.createRecord,
          dataSource: "manageClean",
          objectType: "task",
          fieldsToPopulate: `Follow up on bid ${recordId}`,
          assign: "owner",
        }
      }
    }
  };

  const edges = [
    {
      id: "edge-1",
      source: "trigger-1",
      target: "delay-1",
      type: "smoothstep"
    },
    {
      id: "edge-2",
      source: "delay-1",
      target: "action-1",
      type: "smoothstep"
    }
  ];

  return { nodes: [triggerNode, delayNode, actionNode], edges };
}

export function generateOnboardingTask(recordId: string) {
  const triggerNode = {
    id: "trigger-1",
    type: "trigger",
    position: { x: 100, y: 100 },
    data: {
      properties: {
        ...triggerDefaultData,
        type: "eventBasedTrigger",
        eventType: "on_client_converted",
      }
    }
  };

  const actionNode = {
    id: "action-1",
    type: "action",
    position: { x: 500, y: 100 },
    data: {
      properties: {
        ...actionDefaultData,
        type: "createRecord",
        createRecord: {
          ...actionDefaultData.createRecord,
          dataSource: "manageClean",
          objectType: "task",
          fieldsToPopulate: `Begin onboarding for client from bid ${recordId}`,
          assign: "admin",
        }
      }
    }
  };

  const edges = [
    {
      id: "edge-1",
      source: "trigger-1",
      target: "action-1",
      type: "smoothstep"
    }
  ];

  return { nodes: [triggerNode, actionNode], edges };
}
